import RecoverStep from "./recover_step";
import {attachSelectableHandler} from "../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../utils/recover_consts";

const TEMPLATE = 'restore-type';

export default class RestoreType extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.restore = {};
        data.tmp = { loadingComplete : false, showAppliance : null };
        let url = "/api/localbrowsing/devices/" + data.clientId;
        if (data.applianceId) {
            url += "/" + data.applianceId;
        }

        $.ajax({
            type : "GET",
            url : url,
            success: function (response) {
                data.tmp.showAppliance = !$.isEmptyObject(response.data);
                if (data.deviceId) {
                    // enable browse and recover button if we have localbrowsing data for scoped device
                    data.tmp.showAppliance = !$.isEmptyObject(response.data[data.deviceId]);
                }
                data.tmp.loadingComplete = true;
                fr.render("restoreType");
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    render(data, el, fr) {
        data.render = {
            loadingComplete : data.tmp.loadingComplete,
            showAppliance   : data.tmp.showAppliance
        };
    }

    postRender(data, el, fr) {
        attachSelectableHandler(el,(d) => {
            data.restore.type = d.type;
        });
    }

}
